import React, { useCallback, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { formatDateFromFilterValue } from "@/pages/dashboard/utils/formatDate";
// import { PC_CONSOLE_DEFAULT_FILTER_CONFIG } from "@/pages/dashboard/components/NewFilter/_config";
import { useSelector } from 'umi';
import { InputItemType, filterValueType } from '../../components/NewFilter/_type';
import { useFilterData } from './hooks';
import { getDateDefault } from '../../utils/dateUtils';

// 筛选器路径
const FILTER_PATH = 'wow/index';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const WowFIlter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, path = FILTER_PATH, children, isHaveFilterSave, selectorListApi = '/api/v1/dashboard/wow_selector', timeZone = 0 } = props;
  // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const filterValueRef = useRef<any>(null);
  const { loading, selector } = useFilterData(path, [], true, [], selectorListApi);
  const { latestDate } = selector || {};
  const { seasonInfo } = useSelector((state: any) => ({
    // 初始可能为undefied,在此加兜底
    seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] },
  }));

  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    {
      type: 'rangeDaily',
      key: 'rangeTime',
      default: getDateDefault({timeType: 'day', timeZone, startNum: 2, endNum: 2}),
      extraShortcut: seasonInfo
    },
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: filterValueType, inputList: Array<InputItemType>, isHaveExtendFIlter: boolean) => {
    filterValueRef.current = value;
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter,
      timeType: "Day",
      rangeDateKey: 'rangeDaily',
      selector,
    });
  }, [filterInit]);

  const onConfirm = useCallback((value: filterValueType) => {
    filterValueRef.current = value;
    const obj: any = {
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
      timeType: "Day",
      selector
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'));
  }, [filterConfirm, buttonLogConfig]);

  const onReset = useCallback((value: filterValueType) => {
    filterValueRef.current = value;
    const obj = {
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: true,
      timeType: "Day",
      selector
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'), true);
  }, [filterReset, buttonLogConfig]);

  return <Filter
    filterHideDefaultIsReq={true}
    // pageDefaultSelector={PC_CONSOLE_DEFAULT_FILTER_CONFIG}
    openSticky={openSticky}
    outLatestDate={latestDate}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    outSelector={selector}
    loading={loading}
    onConfirm={onConfirm}
    onReset={onReset}
    isHaveFilterSave={isHaveFilterSave}
  >
    {children}
  </Filter>;
};

export default WowFIlter;
